import {Component, ElementRef, inject, OnInit, signal, ViewChild} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import {NgOptimizedImage} from "@angular/common";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {LocaleService} from "../../../../locale/locale.service";
import {FileUploadService} from "../../../../services/file-upload.service";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ClaimsService} from "../../../../services/claims.service";
import {TextAreaComponent} from "../../../common/text-area/text-area.component";
import {ImageComponent} from "../../../common/image/image.component";
import {SpinnerComponent} from "../../../common/spinner/spinner.component";

@Component({
  selector: 'app-document-upload-police-report',
  imports: [
    FooterComponent,
    HeaderComponent,
    NgOptimizedImage,
    ReactiveFormsModule,
    FormsModule,
    TextAreaComponent,
    ImageComponent,
    SpinnerComponent
  ],
  templateUrl: './document-upload-police-report.component.html',
  styleUrl: './document-upload-police-report.component.css'
})
export class DocumentUploadPoliceReportComponent implements OnInit {
  private formNavigationService = inject(FormNavigationService);
  locale = inject(LocaleService);
  private fileUploadService = inject(FileUploadService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  imageUrls: string[] = [];
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement> | undefined;

  options: { headline: string, caption: string, value: boolean }[] = [];
  radioControl = new FormControl();
  policeReportNotAvailableReason: string | null = null;
  isLoading = signal(false);

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.documentUploadPoliceReport3,
        caption: "",
        value: true
      },
      {
        headline: this.locale.currentTranslation.documentUploadPoliceReport2,
        caption: "",
        value: false
      }
    ];
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.policeReportImageUrls) {
        this.imageUrls = this.claimService.claimReport().policeReportImageUrls;
      }
      if (this.claimService.claimReport()?.policeReportAvailable !== null) {
        this.radioControl = new FormControl(this.claimService.claimReport().policeReportAvailable);
      }
      if (this.claimService.claimReport()?.policeReportNotAvailableReason) {
        this.policeReportNotAvailableReason = this.claimService.claimReport().policeReportNotAvailableReason
      }
    })
  }

  triggerFileInput() {
    if (this.fileInput) {
      const fileInput = this.fileInput;
      fileInput.nativeElement.click();
    }
  }

  onFileSelected($event: Event) {
    const input = $event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.isLoading.set(true);
      this.fileUploadService.uploadImage(file, "police-report").subscribe({
        next: (res: any) => {
          this.imageUrls.push(res["key"])
        },
        complete: () => this.isLoading.set(false),
      });
    }
  }

  removeImage(imageUrl: string) {
    this.imageUrls.splice(this.imageUrls.indexOf(imageUrl), 1);
  }

  setOption(value: boolean) {
    this.radioControl.patchValue(value);
    this.showError = false
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({
        policeReportAvailable: this.radioControl.getRawValue(),
        policeReportImageUrls: this.imageUrls,
        policeReportNotAvailableReason: this.policeReportNotAvailableReason
      });
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['document-upload-police-report']);
      });

    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    if ((rawValue == null || rawValue === true) && this.imageUrls.length <= 0) {
      this.showError = true
      return
    }
    if (rawValue == false && (this.policeReportNotAvailableReason === null || this.policeReportNotAvailableReason.length <= 0)) {
      this.showError = true;
      return;
    }
    this.showError = false
  }
}
